export const filtersTooltipKeys = [
  'filters-general',
  'filters-datapeople',
  'filters-ats',
  'filters-custom',
];
